import { render, staticRenderFns } from "./MyBlog.vue?vue&type=template&id=4aa59342&"
import script from "./MyBlog.vue?vue&type=script&lang=js&"
export * from "./MyBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aa59342')) {
      api.createRecord('4aa59342', component.options)
    } else {
      api.reload('4aa59342', component.options)
    }
    module.hot.accept("./MyBlog.vue?vue&type=template&id=4aa59342&", function () {
      api.rerender('4aa59342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/LockerRoom/SubPages/MyBlog.vue"
export default component.exports